// src/layout/MyLayout.tsx
import { Box, Paper } from "@mui/material";
import { useState } from "react";
import Sidebar from "../components/Sidebar";
import Navbar from "../components/Navbar";

const drawerWidth = 240;
const collapsedDrawerWidth = 60;

const MyLayout = ({ children }: { children: React.ReactNode }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <Box sx={{ display: "flex", minHeight: "100vh", bgcolor: "#f5f5f5" }}>
      <Navbar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <Sidebar open={sidebarOpen} />
      <Box 
        component="main" 
        sx={{ 
          flexGrow: 1,
          transition: theme => theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
          }),
          pt: 8, // Space for the navbar
        }}
      >
        {/* Wrapper with consistent padding */}
        <Box sx={{ p: 3 }}>
          <Paper 
            elevation={2} 
            sx={{ 
              p: 3, 
              borderRadius: 2,
              minHeight: "calc(100vh - 130px)"
            }}
          >
            {children}
          </Paper>
        </Box>
      </Box>
    </Box>
  );
};

export default MyLayout;